import React, { FC } from 'react';

import { StyledCarouselGridContainer } from './grid-carousel.styled';

interface GridCarouselProps {
	cards: JSX.Element[];
	minCardWidth?: number;
	gap?: number;
	dataTestingLabel?: string;
}

export const GridCarousel: FC<GridCarouselProps> = ({
	cards,
	minCardWidth = 280,
	gap,
	dataTestingLabel = 'card-grid-container',
}) => {
	return (
		<StyledCarouselGridContainer data-testing-label={dataTestingLabel} gap={gap} minCardWidth={minCardWidth}>
			{cards.map((card, index) => (
				<React.Fragment key={index}>{card}</React.Fragment>
			))}
		</StyledCarouselGridContainer>
	);
};
